import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NotaFiscalEdicao } from '@/features/nfe/page/edicao/NotaFiscalEdicao';
import { StringToIdpkSchema } from '@/std/schema';

const RouteNotaFiscalParamsSchema = z.object({
    action: z.enum(['editar', 'clonar', 'visualizar']),
    idpk: StringToIdpkSchema,
});

export const Route = createFileRoute('/a/nota-fiscal/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteNotaFiscalParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <NotaFiscalEdicao {...params} />;
}
